import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTieredChargeTableLookup extends Layout {
    sourceTieredChargeTableLookup: DataSource;
    tableCompany: Table;
}
